import { useState } from "react";
import Footer from "../components/Footer/Footer";
import {
  FaPersonRunning,
  FaBicycle,
  FaWeightHanging,
  FaDumbbell,
  FaLink,
  FaShieldHalved,
  FaShoePrints,
  FaArrowsUpDown,
  FaBasketball,
  FaUsers,
  FaLock,
  FaShower,
  FaUserShield,
  FaXmark,
} from "react-icons/fa6";

// Equipment images
import treadmillImg from "../images/gallery/Treadmills.png";
import spinbikeImg from "../images/gallery/spinbike.jpg";
import squatRackImg from "../images/gallery/Squat_Racks.webp";
import benchPressImg from "../images/gallery/bench_press.jpg";
import crossoverImg from "../images/gallery/Crossover_Machine.jpg";
import smithMachineImg from "../images/gallery/Smith_machine.webp";
import legPressImg from "../images/gallery/leg_press.jpg";
import latPulldownImg from "../images/gallery/Lat_Pulldown.jpg";
import dumbbellImg from "../images/gallery/dumble_set.jpg";
import kettlebellImg from "../images/gallery/kettlebell-medicine.webp";

function Equipments() {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxImg, setLightboxImg] = useState("");
  const [lightboxTitle, setLightboxTitle] = useState("");
  const [activeFilter, setActiveFilter] = useState("All");

  const equipments = [
    {
      name: "Premium Commercial Treadmills",
      cat: "Cardio",
      Icon: FaPersonRunning,
      img: treadmillImg,
      desc: "High-performance motorized treadmills with cushioned decks, incline control, and heart-rate monitoring for safe cardio sessions.",
    },
    {
      name: "Spin Bikes & Ellipticals",
      cat: "Cardio",
      Icon: FaBicycle,
      img: spinbikeImg,
      desc: "Magnetic-resistance spin bikes and low-impact ellipticals for intense calorie-burning workouts without stressing your joints.",
    },
    {
      name: "Olympic Squat Racks",
      cat: "Strength & Power",
      Icon: FaWeightHanging,
      img: squatRackImg,
      desc: "Competition-standard squat racks with adjustable safety catches and J-hooks for heavy squatting and overhead pressing.",
    },
    {
      name: "Bench Press Stations",
      cat: "Strength & Power",
      Icon: FaDumbbell,
      img: benchPressImg,
      desc: "Flat, incline, and decline bench press stations built for heavy loads with wide safety spotting arms.",
    },
    {
      name: "Cable Crossover Machine",
      cat: "Cable Systems",
      Icon: FaLink,
      img: crossoverImg,
      desc: "Heavy-duty dual-pulley cable crossover with adjustable height settings for full-body isolation and functional movements.",
    },
    {
      name: "Smith Machine",
      cat: "Strength & Safety",
      Icon: FaShieldHalved,
      img: smithMachineImg,
      desc: "Guided barbell path smith machine with counterbalanced weight for safe solo lifting and controlled movements.",
    },
    {
      name: "Leg Press & Hack Squat",
      cat: "Leg Day Core",
      Icon: FaShoePrints,
      img: legPressImg,
      desc: "45° angled leg press and hack squat combo machine to build massive quads, glutes, and hamstrings safely.",
    },
    {
      name: "Lat Pulldown & Low Row",
      cat: "Back Training",
      Icon: FaArrowsUpDown,
      img: latPulldownImg,
      desc: "Dual-station lat pulldown and seated low row for sculpting a wide, powerful back with smooth cable resistance.",
    },
    {
      name: "Dumbbell Sets (Up to 50kg)",
      cat: "Free Weights",
      Icon: FaDumbbell,
      img: dumbbellImg,
      desc: "Full rack of rubber-coated hex dumbbells from 2.5kg to 50kg for versatile strength training and muscle isolation.",
    },
    {
      name: "Kettlebells & Medicine Balls",
      cat: "Functional Fitness",
      Icon: FaBasketball,
      img: kettlebellImg,
      desc: "Competition kettlebells and slam-proof medicine balls for explosive power training, swings, and core conditioning.",
    },
  ];

  const facilities = [
    {
      name: "Unisex Workout Zone",
      desc: "Safe, inclusive, clean, and friendly workout space engineered to accommodate all members comfortably.",
      Icon: FaUsers,
    },
    {
      name: "Individual Locker Facility",
      desc: "Secure digital locker storage to safeguard your gym bags and belongings while you train.",
      Icon: FaLock,
    },
    {
      name: "Private Changing Rooms & Showers",
      desc: "Well-maintained, clean, and hygienic changing spaces to freshen up before or after work.",
      Icon: FaShower,
    },
    {
      name: "Certified On-Floor Coaches",
      desc: "Constant professional support on the floor to correct form, assist with spotting, and guide safety.",
      Icon: FaUserShield,
    },
  ];

  const categories = ["All", ...new Set(equipments.map((eq) => eq.cat))];

  const filteredEquipments =
    activeFilter === "All"
      ? equipments
      : equipments.filter((eq) => eq.cat === activeFilter);

  const openLightbox = (img, title) => {
    setLightboxImg(img);
    setLightboxTitle(title);
    setLightboxOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    setLightboxImg("");
    setLightboxTitle("");
    document.body.style.overflow = "auto";
  };

  return (
    <>
      {/* Lightbox Modal */}
      {lightboxOpen && (
        <div
          className="fixed inset-0 z-[9999] flex items-center justify-center p-4"
          onClick={closeLightbox}
          style={{ backgroundColor: "rgba(0,0,0,0.92)" }}
        >
          <button
            onClick={closeLightbox}
            className="absolute top-4 right-4 sm:top-6 sm:right-6 text-white text-[28px] sm:text-[36px] hover:text-[#ffd600] transition z-[10000] w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center"
            aria-label="Close lightbox"
          >
            <FaXmark />
          </button>
          <div
            className="relative max-w-[90vw] max-h-[85vh] flex flex-col items-center"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={lightboxImg}
              alt={lightboxTitle}
              className="max-w-full max-h-[75vh] object-fit rounded-lg shadow-2xl"
            />
            {lightboxTitle && (
              <p className="text-white text-[14px] sm:text-[18px] font-bold mt-3 sm:mt-4 text-center">
                {lightboxTitle}
              </p>
            )}
          </div>
        </div>
      )}

      <section className="bg-black text-white min-h-screen">
        {/* Hero Banner */}
        <div className="login-banner relative justify-center flex bg-brand-yellow">
          <h1 className="text-white absolute bottom-[20px] sm:bottom-[25px] text-[26px] sm:text-[34px] md:text-[40px] font-extrabold uppercase text-center px-4">
            Gym Equipments
          </h1>
        </div>

        {/* Introduction */}
        <div className="container page-padding py-12 sm:py-16 md:py-20 text-center max-w-4xl">
          <h2 className="text-[24px] sm:text-[28px] md:text-[32px] font-bold mb-4 sm:mb-6 text-brand-yellow">
            Premium Heavy-Duty Gear For Champions
          </h2>
          <p className="text-neutral-400 text-[14px] sm:text-[16px] leading-relaxed">
            At{" "}
            <span className="text-brand-yellow font-bold">
              FAT2FIT Unisex Fitness Centre
            </span>
            , we believe that premium gear is essential for joint safety, proper
            muscle resistance, and results. We house heavy-duty, commercial-grade
            equipment to give you the ultimate workout experience.
          </p>
        </div>

        {/* Category Filter Pills */}
        <div className="container page-padding pb-4 sm:pb-6">
          <div className="flex flex-wrap justify-center gap-2 sm:gap-3">
            {categories.map((cat) => (
              <button
                key={cat}
                onClick={() => setActiveFilter(cat)}
                className={`px-4 py-2 sm:px-5 sm:py-2.5 rounded-full text-[11px] sm:text-[13px] font-bold uppercase tracking-wider transition-all duration-300 border ${
                  activeFilter === cat
                    ? "bg-[#ffd600] text-black border-[#ffd600] shadow-lg shadow-[#ffd60033]"
                    : "bg-transparent text-neutral-400 border-neutral-700 hover:border-[#ffd600] hover:text-[#ffd600]"
                }`}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>

        {/* Equipment Grid with Images */}
        <div className="bg-[#111] py-12 sm:py-16 md:py-20">
          <div className="container page-padding">
            <h2 className="text-[24px] sm:text-[28px] md:text-[30px] font-bold text-center mb-10 sm:mb-14 relative">
              Available Gym Gear
              <span className="w-[80px] h-[4px] bg-[#ff0336] absolute -bottom-3 left-1/2 -translate-x-1/2"></span>
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6 lg:gap-7">
              {filteredEquipments.map((eq, i) => (
                <div
                  key={i}
                  className="group bg-black rounded-2xl border border-neutral-800 overflow-hidden hover:border-[#ffd600] transition-all duration-500 shadow-lg hover:shadow-[0_8px_40px_rgba(255,214,0,0.12)] hover:-translate-y-1"
                >
                  {/* Equipment Image */}
                  <div
                    className="relative h-[300px] sm:h-[320px] overflow-hidden cursor-pointer"
                    onClick={() => openLightbox(eq.img, eq.name)}
                  >
                    <img
                      src={eq.img}
                      alt={eq.name}
                      className="w-full h-full object-fit transition-transform duration-700 group-hover:scale-110"
                    />
                    {/* Overlay gradient */}
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-60 group-hover:opacity-40 transition-opacity duration-500"></div>
                    {/* Category badge */}
                    <span className="absolute top-3 left-3 bg-[#ff0336] text-white text-[10px] sm:text-[11px] font-bold uppercase tracking-wider px-3 py-1 rounded-full">
                      {eq.cat}
                    </span>
                  </div>

                  {/* Equipment Info */}
                  <div className="p-5 sm:p-6">
                    <div className="flex items-start gap-3 sm:gap-4 mb-3">
                      <div className="w-9 h-9 sm:w-10 sm:h-10 bg-neutral-900 border border-neutral-700 rounded-lg flex items-center justify-center text-[#ffd600] text-[14px] sm:text-[16px] flex-shrink-0 group-hover:bg-[#ffd600] group-hover:text-black transition-all duration-300">
                        <eq.Icon />
                      </div>
                      <h3 className="text-[15px] sm:text-[17px] font-bold leading-snug">
                        {eq.name}
                      </h3>
                    </div>
                    <p className="text-neutral-500 text-[12px] sm:text-[13px] leading-relaxed">
                      {eq.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Special Facilities */}
        <div className="bg-[#111] py-12 sm:py-16 md:py-20">
          <div className="container page-padding">
            <h2 className="text-[24px] sm:text-[28px] md:text-[30px] font-bold text-center mb-12 sm:mb-16 relative">
              Special Facilities
              <span className="w-[80px] h-[4px] bg-brand-yellow absolute -bottom-3 left-1/2 -translate-x-1/2"></span>
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5 sm:gap-6 lg:gap-8">
              {facilities.map((fac, i) => (
                <div
                  key={i}
                  className="group bg-black border border-neutral-800 p-6 sm:p-8 rounded-2xl flex items-start gap-4 sm:gap-5 hover:border-[#ffd600] transition-all duration-400 shadow-lg hover:shadow-[0_4px_30px_rgba(255,214,0,0.08)]"
                >
                  <div className="w-12 h-12 sm:w-14 sm:h-14 bg-neutral-900 border border-neutral-700 rounded-xl flex items-center justify-center text-[#ff0336] text-[20px] sm:text-[22px] flex-shrink-0 group-hover:bg-[#ff0336] group-hover:text-white transition-all duration-300">
                    <fac.Icon />
                  </div>
                  <div>
                    <h3 className="text-[17px] sm:text-[20px] font-bold text-[#ffd600] mb-2 sm:mb-3">
                      {fac.name}
                    </h3>
                    <p className="text-neutral-400 text-[13px] sm:text-[14px] leading-relaxed">
                      {fac.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <Footer />
      </section>
    </>
  );
}

export default Equipments;
